const Tablet = () => {
    return null;
};

export default Tablet;
